import React, {Fragment, ReactNode} from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "../auth/AuthenticationProvider";
import {useStaffRole} from "../auth/useStaffRole";
import RequestAccess from "./RequestAccess";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const {authResult} = useAuth();
  const staffRole = useStaffRole();
  const location = useLocation();

  if (!authResult) {
    return <Navigate to={"/login"} replace={true} state={{from: location}} />;
  }

  if (!staffRole) {
    return <RequestAccess />;
  }

  return <Fragment>{props.children}</Fragment>;
};

export default ProtectedRoute;
